export enum Events {
    BEGIN_ONBOARDING = "Onboarding Process Started",
    COMPLETED_PROFILE = "Profile Page Completed",
    COMPLETED_ROLE = "Role Page Completed",
    COMPLETED_BUILDING_INFO = "Building Information Entered",
    COMPLETED_UTILITY_INFO = "Utility Information Entered",
    COMPLETED_ONBOARDING = "Onboarding Completed"
}